import { render, staticRenderFns } from "./block-post-dialog.vue?vue&type=template&id=c0dc7d3c&"
import script from "./block-post-dialog.vue?vue&type=script&lang=js&"
export * from "./block-post-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports